import React from 'react';
import styled from 'styled-components';
import logo from '../assets/images/footer-logo.png';

const Footer = () => {
  return (
    <StyledFooter>
      <div className="container">
        <FooterContent>
          <FooterLogo>
            <img className="footer-logo" src={logo} alt="Pulvora Logo" />
          </FooterLogo>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; {new Date().getFullYear()} Pulvora. All rights reserved.</p>
          {/* <SocialLinks>
            <SocialLink href="#">Twitter</SocialLink>
            <SocialLink href="#">LinkedIn</SocialLink>
            <SocialLink href="#">Facebook</SocialLink>
          </SocialLinks> */}
        </FooterBottom>
      </div>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  // background-color: #f8f9f8;
  padding: 60px 0 30px;
`;

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 40px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const FooterLogo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  
  .footer-logo {
    width: 235px;
    height: auto;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 60px;
  
  @media (max-width: 768px) {
    gap: 30px;
  }
`;

const FooterLinkColumn = styled.div`
  h4 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #333;
  }
`;

const FooterLink = styled.a`
  display: block;
  color: #666;
  text-decoration: none;
  margin-bottom: 10px;
  font-size: 14px;
  
  &:hover {
    color: #00D68F;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
  border-top: 1px solid #eee;
  width: 100%;
  
  p {
    color: #666;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const SocialLink = styled.a`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  
  &:hover {
    color: #00D68F;
  }
`;

export default Footer;
